import { Grid, styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { Button, Input } from "../../../../../../components/Form";
import { MapStatus } from "../../../../../../util/enums";

const getSquareBackgroundColor = (status?: string) => {
  switch (status?.toLowerCase()) {
    case MapStatus.EMPTY.toLowerCase():
      return "#CCDEEE";
    case MapStatus.LOADED.toLowerCase():
      return "#53B1FD";
    case MapStatus.MIXED.toLowerCase():
      return "#FAA7E0";
    case MapStatus.INACTIVE.toLowerCase():
      return "#98A2B3";
    default:
      return "#CCDEEE";
  }
};

export const MapSquare = styled("div")(
  ({ selected, status }: { selected: boolean; status?: string }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "2rem",
    height: "2rem",
    maxWidth: "2rem",
    maxHeight: "2rem",
    borderRadius: "1px",
    background: selected ? "#12B76A" : getSquareBackgroundColor(status),
    marginBottom: "0.5rem",
    "& button": {
      "& span": {
        display: "none",
      },
    },
  })
);

export const MapInput = styled(Input)(({ isViewMode }: { isViewMode: boolean }) => ({
  display: "flex",
  flexDirection: "column",
  width: "2rem",
  height: "2rem",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "4px",
  background: "#FFF",
  "& > div > fieldset": {
    borderRadius: "4px",
    border: isViewMode ? "none" : "1px solid #E4E7EC",
  },
  "& > div > input": {
    padding: 0,
    color: "#308CDB",
    fontSize: "16px",
    fontFamily: "Manrope",
    fontWeight: 700,
    lineHeight: "150%",
    textAlign: "center",
  },
}));

export const Square = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "2rem",
  height: "2rem",
  minWidth: "2rem",
  minHeight: "2rem",
  borderRadius: "1px",
  background: "#FFFFFF",
  marginBottom: "0.5rem",
}));

export const MapRow = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: "0.5rem",
  "& > .MuiFormControl-root": {
    minWidth: "2rem",
    minHeight: "2rem",
  },
}));

export const TopViewText = styled("p")(() => ({
  color: "#465869",
  fontSize: "12px",
  fontFamily: "Manrope",
  fontWeight: 500,
  lineHeight: "160%",
  marginBottom: "0.5rem !important",
}));

export const GridContainerTitle = styled("span")(() => ({
  color: "#475467",
  fontSize: "16px",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "24px",
}));

export const ContainerMap = styled("div")(() => ({
  width: "100%",
  height: "100%",
  background: "#FFF",
  border: "1px solid #E4E7EC",
  borderRadius: "12px",
  padding: "1.5rem 1rem",
}));

export const ContainerMapWrapper = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
  width: "100%",
}));

export const MapCellsWrapper = styled(Grid)(() => ({
  width: "100% !important",
  overflow: "auto",
}));

export const MapCellsContainer = styled("div")(() => ({
  display: "flex",
  gap: 16,
}));

export const MapCellsLevelsWrapper = styled(Grid)(() => ({
  marginTop: "-28px !important",
}));

export const CellButton = styled(Button)(() => ({
  minWidth: "2rem !important",
  padding: 0,
}));

export const useStyles = makeStyles(() => ({
  scrollingDiv: {
    display: "inline-block",
    animation: "horizontalScroll 1.2s linear ease-in-out",
  },
  "@keyframes horizontalScroll": {
    from: {
      transform: "translateX(0%)",
    },
    to: {
      transform: "translateX(100%)",
    },
  },
}));
